export default "__VITE_ASSET__RWP0tHI7__";